import { quizErrorMessages } from '@repo/lib/messages/quizErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useGetQuizPublic(id?: string, enabled = true) {
  const getQuiz = useQuery({
    queryKey: [QuizKey.QUIZ_PUBLIC, id],
    queryFn: () => QuizService.getQuizPublic(id).then((response) => response.data),
    enabled: !!id && enabled,
  });

  const errorMessage = useErrorMessage(getQuiz.error, quizErrorMessages);

  return { ...getQuiz, errorMessage };
}
